import '../../brand/tokens.css';
import './styles.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { startUploads } from './game/uploads.ts';
import { initNative } from './lib/native.ts';
import { initSession } from './lib/session.ts';
import { client } from './online/client.ts';

void initNative();
void initSession().then(() => {
  client.start();
  startUploads();
});

// Warm the image cache so the first board never paints with missing pieces.
for (const c of ['w', 'b']) {
  for (const k of ['P', 'N', 'B', 'R', 'Q', 'K']) new Image().src = `/art/${c}${k}.svg`;
  new Image().src = `/art/snail-${c}.svg`;
}
new Image().src = '/art/boom.svg';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
